// Direct Representative Discrepancy Audit — run detail view filters (ADR-130).
import {
  DISCREPANCY_MAPPING_STATUSES,
  DISCREPANCY_COMPARABLE_MAPPING_STATUSES,
} from '../../../constants/discrepancyMappingStatuses';
import { DISCREPANCY_RADAR_ONLY_REASONS } from '../../../constants/discrepancyRadarOnly';

const KNOWN_RADAR_ONLY_REASONS = new Set(Object.values(DISCREPANCY_RADAR_ONLY_REASONS));

// ADR-130: "Radar only" is its own view — those rows have no reported
// representative to compare, so they never mix with the comparison views.
export const VIEW_OPTIONS = [
  { value: 'mismatches', label: 'Mismatches only' },
  { value: 'matches',    label: 'Matches only' },
  { value: 'all',        label: 'All compared' },
  { value: 'radarOnly',  label: 'Radar only' },
];

export const DEFAULT_FILTERS = {
  matchFilter: 'mismatches',
  mismatchReason: [],
  mappingStatus: [],
  // ADR-130: Radar only view — every reason by default
  radarOnlyReason: [],
  employee: null, // full employee object (or null) — sent to the API as employeeId.
};

export const matchFilterToParam = (matchFilter) => {
  if (matchFilter === 'matches')    return 'true';
  if (matchFilter === 'all')        return undefined;
  if (matchFilter === 'radarOnly')  return undefined;
  return 'false'; // mismatches default
};

/**
 * ADR-130: map the "Show" view to API filters. The comparison views never
 * include RADAR_ONLY rows (they have no reported representative); the Radar
 * only view selects them, filtered by reason.
 */
export const buildViewFilters = (filters) => {
  if (filters.matchFilter === 'radarOnly') {
    return {
      mappingStatus: [DISCREPANCY_MAPPING_STATUSES.RADAR_ONLY],
      // Drop reasons no longer known (e.g. filters restored from browser history).
      radarOnlyReason: (filters.radarOnlyReason || []).filter((r) => KNOWN_RADAR_ONLY_REASONS.has(r)),
    };
  }
  return {
    match: matchFilterToParam(filters.matchFilter),
    mismatchReason: filters.mismatchReason,
    mappingStatus: filters.mappingStatus?.length > 0
      ? filters.mappingStatus
      : DISCREPANCY_COMPARABLE_MAPPING_STATUSES,
  };
};

